<template>
  <v-row>
    <v-col class="pa-0">
      <v-footer class="white">
        <v-row>
          <v-col class="pa-0">
            <h1 style="text-align: center" class="text-subtitle-1">
              Copyright © {{ new Date().getFullYear() }} VIAplanner - Data updated for the 2021 - 2022
              school year
            </h1>
          </v-col>
        </v-row>
      </v-footer>
    </v-col>
  </v-row>
</template>

<script>
export default {};
</script>